// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import HydrantMapItemListResultModel from '../../model/hydrant-map-item-list-result-model';
import HydrantMapItemListResultDTO from '../dto/hydrant-map-item-list-result-dto';
import dtoSchema from '../schemas/hydrant-map-item-list-result-schema';
import HydrantMapItemModel from '../../model/hydrant-map-item-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class HydrantMapItemListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<HydrantMapItemListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => HydrantMapItemModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: HydrantMapItemModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<HydrantMapItemListResultDTO>): HydrantMapItemListResultModel;
  static toModel(dto: DeepPartial<HydrantMapItemListResultDTO> | undefined | null): HydrantMapItemListResultModel | undefined;
  static toModel(dto: DeepPartial<HydrantMapItemListResultDTO> | undefined | null): HydrantMapItemListResultModel | undefined {
    return dto ? new HydrantMapItemListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<HydrantMapItemListResultModel> | HydrantMapItemListResultModel): HydrantMapItemListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as HydrantMapItemListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for HydrantMapItemListResultModel, can not map to HydrantMapItemListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
